import { useContext } from "react";
import { AnnouncementsContext } from "../../contexts/announcementsContext";
import { AnnouncementMarquee } from "./AnnouncementMarquee";

export const Footer = () => {
  const { data, loading } = useContext(AnnouncementsContext);
  const announcements = !loading && data?.allAnnouncement;

  return (
    <div className="navbar navbar-fixed-bottom footer-wrapper">
      <AnnouncementMarquee announcements={announcements} />
    </div>
  );
};
